import { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-teses.jpeg";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { Modal } from "../../components/Modal";
import { mapInitialSearch, Response, Search, useDissertations } from "../../hooks/useDissertations";
import { Container } from "../../theme/styles";
import { Form } from "./components/Form";
import { Results } from "./components/Results";
import { Submit } from "./helpers/submit";
import mock from "../../mocks/info";
import { Description } from "../../components/Description";
import medias_url from "../../mocks/social_media";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";

function Theses() {
  usePageTrack();

  const pathname = useLocation().pathname;
  const [results, setResult] = useState<Response|null>(null);
  const [page, setPage] = useState<number>(1);
  const [order, setOrder] = useState<string>('');
  const initialSearch = pathname?.split('/')[2];
  const firstData: Response = useDissertations(initialSearch);
  const firstSearch = {nivel: mapInitialSearch(initialSearch)}
  const [search, setSearch] = useState<Search|null>(initialSearch? firstSearch : null);

  const options: any = []; //usePageAttributes(pathname?.split('/')[1], mapAttributes);

  const [clickedInfo, setClickedInfo] = useState(mock);
  const [isModalOpen, setIsModalOpen] = useState(false);

  async function submit(_search: Search|null, _page: number = 0, _order: string = '') {
    if(!_search) _search = search;
    if(!_page) _page = page;
    if(!_order) _order = order;
    const result = await Submit(_search, _page, _order);
    setResult(result);
    setSearch(_search);
    setPage(_page)
    setOrder(_order);
  }

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Description>
        Estamos em constante busca por novas teses e dissertações sobre direitos autorais. Por isso criamos o Banco de Teses e Dissertações, cujo objetivo é reunir e disponibilizar ao público a produção acadêmica nacional de qualidade, inclusive quanto às discussões transversais aos direitos de autor. Todas as teses e dissertações aqui estão licenciadas em Creative Commons CC BY NC ND.  Caso deseje disponibilizar sua tese, entre em contato pelo e-mail {`${medias_url.contactEmail}`}.
      </Description>
      <Content>
        <Form 
          formAttr={options.form} 
          initialSearch={initialSearch}
          submit={submit}
        />
        <Results 
          results={results?.results || firstData.results} 
          pagination={results?.pagination || firstData?.pagination} 
          submit={submit}
          onClick={(clicked) => {
            setClickedInfo(clicked);
            setIsModalOpen(true);
          }}
        />
        <Modal isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {clickedInfo.map(info => (
          <div key={info.title} ref={info.content}>
              <span>{info.title}</span>
              <section>{info.content}</section>
            </div>
          ))}
        </Modal>
      </Content>
      <Footer />
    </>
  );
}

export default Theses;

const Content = styled(Container)`
  padding: 32px 0 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
  }
`;